import genericRule from '../../namespace/relation/doingValidate_namespace_relation';
import { errors as _errors } from 'lib_ui-primitives';

export default {
    ...genericRule,
    excludedNamespaceRelations: [],
    namespace: 'backbone',
    relation: 'featureFlag',
    logic: requireCriteriaOnFeatureFlags
};

/**
 *
 * @param {{data:{
 *     newRecord:{
 *        selectionOr: Array<
 *          {'metaui:useCase'?: Array<{_id?: string, title: string}>}|
 *          {'identity:role'?: Array<{_id?: string, title: string}>}|
 *          {'identity:backboneUser'?: Array<{_id?: string, title: string}>}|
 *          {'identity:tenant'?: Array<{_id?: string, title: string}>|
 *          null}>
 *   }
 * }}} message
 * @returns
 */
async function requireCriteriaOnFeatureFlags({ data }) {
    const { newRecord: { selectionOr } = {} } = data;

    let noCriteria = !selectionOr || selectionOr.length === 0;
    if (!noCriteria) {
        //the other invalid scenario is when every selectionOr condition has no criteria, or each criteria only has properties that are empty arrays.
        noCriteria = selectionOr.every(condition => isEmptyCondition(condition));
    }
    if (noCriteria) {
        const message = 'At least one selection criteria is required for a feature flag.';
        throw new _errors.ValidationError(message, {});
    }
    // filter out any empty selectionOr entries, or where the _id is not defined
    data.newRecord.selectionOr = selectionOr.filter(condition => {
        return !isEmptyCondition(condition);
    });
    return data;
}

function isEmptyCondition(condition) {
    return (
        !condition ||
        Object.keys(condition).length === 0 ||
        Object.values(condition).every(value => {
            return !value || !Array.isArray(value) || value.length === 0 || value.every(item => !item || !item._id);
        })
    );
}
